import { instance } from "libs/api";

import { Category } from "../../categories.types";
import { ApiRoutesCategories } from "./../../constants";
import { CreateSubCategoryPayload } from "./createSubCategory.types";

export const requestCreateSubCategory = async (
  body: CreateSubCategoryPayload
): Promise<Category> => {
  return await instance.post(ApiRoutesCategories.SubCategory, body);
};
